import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../firebase/config";
import { TalesFaq } from "../../../utils/types/TalesFaq";

export const toggleFaqVisibility = createAsyncThunk(
  "faq/toggleVisibility",
  async (faq: TalesFaq) => {
    try {
      const querySnapshot = await db
        .collection("faq")
        .where("question", "==", faq.question)
        .get();

      return querySnapshot.docs[0].ref.set({ ...faq, show: !faq.show });
    } catch (e: any) {
      console.log(e);

      return Promise.reject(
        `Faq non ${faq.show ? "nascosta" : "mostrata"}, ${e.message}`,
      );
    }
  },
);
